import { getImageBase64, loadImageDom } from '../fs/image.utils';

/**
 * 获取canvas渲染的灰度值
 * @param canvasEl
 * @returns
 */
export const getCanvasGrayValue = async (canvasEl: HTMLCanvasElement) => {
  const ctx = canvasEl.getContext('2d', {
    willReadFrequently: true
  }) as CanvasRenderingContext2D;
  const { width, height } = canvasEl;
  const imgData = ctx.getImageData(0, 0, width, height).data;
  let sum = 0;
  for (let i = 0; i < width * height; i++) {
    const r = imgData[i * 4];
    const g = imgData[i * 4 + 1];
    const b = imgData[i * 4 + 2];
    sum += r + g + b;
  }
  return sum / (width * height) / 3;
};

// 通过canvas绘制圆角矩形，4个圆角部分为黑色，中间部分为透明
export const getRoundRectangle = (data: {
  width: number;
  height: number;
  radius: number;
}) => {
  const { width, height, radius } = data;
  const canvas = document.createElement('canvas');

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  // 先填充整个Canvas为黑色
  ctx.fillStyle = 'black';
  ctx.fillRect(0, 0, width, height);

  // 设置合成模式为"destination-out"，使后续绘制区域变为透明
  ctx.globalCompositeOperation = 'destination-out';

  // 绘制圆角矩形路径并填充，这部分会变为透明
  ctx.roundRect(0, 0, width, height, radius);
  ctx.fill();

  // 恢复默认合成模式
  ctx.globalCompositeOperation = 'source-over';

  return canvas.toDataURL('image/png');
};

export const roundImage = async (data: {
  imageFilename: string;
  radius: number;
  type: 'image/png' | 'image/webp';
}) => {
  const { imageFilename, radius, type } = data;

  const imgData = await getImageBase64(imageFilename);
  if (!imgData) throw new Error('图片加载失败');

  const imgDom = await loadImageDom(imgData);
  if (!imgDom) throw new Error('图片加载失败');
  const { width, height } = imgDom;

  const canvas = document.createElement('canvas');

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('ctx为空');

  // 绘制圆角矩形路径并填充，这部分会变为透明
  ctx.roundRect(0, 0, width, height, radius);
  ctx.clip();

  // 绘制图片
  ctx.drawImage(imgDom, 0, 0);

  return canvas.toDataURL(type);
};
